// @ts-nocheck

import React, {
  useState,
  useEffect,
  useCallback,
  FunctionComponent,
} from 'react'
import debounce from 'lodash/debounce'
import { get } from 'lodash'
import { Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import closeCross from 'Shared/icons/close-cross.svg'
import { ModalHeader } from 'Stories/ModalHeader/ModalHeader.stories'
import { GreenBtn, GreyBtnDisabled } from 'Stories/Button/Button.stories'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import CustomScrollDiv from 'Shared/custom/CustomScrollDiv'
import { ModalSubHeader } from 'Stories/ModalSubHeader/ModalSubHeader.stories'
import { IconClose } from 'Stories/Icon/Icon.stories'
import {
  getSpotifyArtists as onGetSpotifyArtists,
  getArtistGenres as onGetArtistGenres,
} from 'Redux/actions/artistsActions'

import { setArtistsToInitialState } from 'Redux/actions/trackActions'

import ListComponent from 'Containers/ui/ParamsSelect/ListComponent'
import CheckArtistFromSearch from '../CheckArtistFromSearch'
import SimilarArtistSearchForm from '../SimilarArtistSearchForm'

import { SimilarArtistPopupProps } from './SimilarArtistPopupProps'
import {
  SimilarArtistContainer,
  WrapperRelativeArtists,
  GenresUnchecked,
  StyledDiv,
  StyledModalSubHeader,
  WrapperForCloseBtn,
  ModalSubHeaderContainer,
  SmallButton,
  ButtonContainer,
  ListWrapper,
} from './styles'

const SimilarArtistPopup: FunctionComponent<SimilarArtistPopupProps> = ({
  accessToken,
  toggle,
  modal,
  selectedGenres,
  flow,
  campaignId,
  onChangeGenresFromArtist,
}) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const [searchArtists, setSearchArtist] = useState('')
  const [checkArtist, setCheckArtist] = useState(null)
  const [artistsList, setArtistsList] = useState([])
  const [selectedArtistGenresList, setSelectedArtistGenresList] = useState([])
  const [searchError, setSearchError] = useState(false)
  const [errorAnswerSpotify, setErrorAnswerSpotify] = useState(false)
  const [chosenListIsOpen, setChosenListIsOpen] = useState<boolean>(false)
  const [selectedItems, setSelectedItems] = useState([])

  useEffect(() => {
    selectedArtistGenresList.forEach(item => {
      const validSelectItem = {
        value: item.id,
        label: item.genre_name,
        selected: item.isCheked,
      }
      if (
        selectedItems.length > 0 &&
        item.isCheked &&
        !selectedItems.find(y => y.id !== validSelectItem.value)
      ) {
        setSelectedItems(items => [...items, validSelectItem])
      }
      if (!item.isCheked) {
        setSelectedItems(items => items.filter(item => item.value !== item.id))
      }
    })
  }, [selectedArtistGenresList])

  useEffect(() => {
    selectedGenres.forEach(item => {
      const validSelectItem = {
        value: item.value,
        label: item.label,
        selected: true,
      }
      if (
        !selectedItems.find(selItem => selItem.value === item.value) &&
        !!selectedArtistGenresList.find(item => item.id === item.value)
      ) {
        setSelectedItems(items => [...items, validSelectItem])
      }

      const listSelectedId = selectedGenres.map(item => item.value)

      setSelectedItems(items =>
        items.filter(item => listSelectedId.includes(item.value))
      )
    })
  }, [selectedGenres])

  const sendArtists = (search: string) => {
    if (search.length === 0) return

    const apiSearch = `https://api.spotify.com/v1/search?q=${search}&type=artist`
    dispatch(
      onGetSpotifyArtists(apiSearch, accessToken, (error, payload) => {
        if (error) {
          const errorMessage = get(error, 'error.message', null)
          if (errorMessage === 'The access token expired') {
            setSearchError(true)
          } else {
            setErrorAnswerSpotify(true)
          }
        }

        if (!payload) return
        const { artists } = payload

        if (artists.items) {
          const artistsWithOutGenre = [...artists.items].filter(
            item => item !== null && item.genres.length !== 0
          )
          setArtistsList([...artistsWithOutGenre])
        }
      })
    )
  }

  const handleSetSearchToInitial = () => {
    setArtistsList([])
    dispatch(setArtistsToInitialState())
  }

  const updateArtists = () => sendArtists(searchArtists)
  const delayedArtists = useCallback(debounce(updateArtists, 1000), [
    searchArtists,
  ])

  useEffect(() => {
    setCheckArtist(null)
    setSelectedArtistGenresList([])
    delayedArtists()
    // eslint-disable-next-line consistent-return
    return delayedArtists.cancel
  }, [searchArtists, delayedArtists])

  useEffect(() => {
    if (selectedArtistGenresList.length === 0) return
    const genresIsCheked = selectedArtistGenresList.map(item => ({
      ...item,
      isCheked: !!selectedGenres.find(genre => genre.value === item.id),
    }))
    setSelectedArtistGenresList(genresIsCheked)
  }, [selectedGenres])

  const handleSetArtistGenresList = ({ artistId, artistName }) => {
    setCheckArtist(artistName)

    dispatch(
      onGetArtistGenres(artistId, (error, payload) => {
        if (error) {
          const errorMessage = get(error, 'error.message', null)
          if (errorMessage === 'The access token expired') {
            setSearchError(true)
          } else {
            setErrorAnswerSpotify(true)
          }
        }

        if (!payload) return
        const { artist_genres } = payload

        if (artist_genres.length > 0) {
          const genresIsCheked = artist_genres.map(item => ({
            ...item,
            playlists_count: item.PlaylistGenres?.length,
            isCheked: !!selectedGenres.find(genre => genre.value === item.id),
          }))
          setSelectedArtistGenresList(genresIsCheked)
        }
      })
    )

    setArtistsList([])
    handleSetSearchToInitial()
  }

  const handleCheckArtistGenre = genre_name => {
    const checkArtistGenre = selectedArtistGenresList.map(genre => {
      if (genre_name === genre.genre_name) {
        return {
          ...genre,
          isCheked: true,
        }
      }
      return { ...genre }
    })
    setSelectedArtistGenresList(checkArtistGenre)
  }

  const handleUncheckArtistGenre = genre_name => {
    const checkArtistGenre = selectedArtistGenresList.map(genre => {
      if (genre_name === genre.genre_name) {
        return {
          ...genre,
          isCheked: false,
        }
      }
      return { ...genre }
    })
    setSelectedArtistGenresList(checkArtistGenre)
  }

  const onSubmitDesktop = () => {
    onChangeGenresFromArtist(selectedArtistGenresList)
    toggle()
  }

  const onSubmitMobile = () => {
    const listSelectedId = selectedItems.map(item => item.value)

    const list = selectedArtistGenresList.map(item => {
      if (listSelectedId.includes(item.id)) {
        return {
          id: item.id,
          genre_name: item.genre_name,
          isCheked: true,
        }
      }
      return {
        id: item.id,
        genre_name: item.genre_name,
        isCheked: false,
      }
    })
    onChangeGenresFromArtist(list)
    toggle()
  }

  useEffect(() => {
    if (!searchArtists) {
      setArtistsList([])
    }
  }, [searchArtists])

  return (
    <div>
      <Desktop>
        <Modal
          fade={false}
          className="modal-dialog--success modal-dialog--header search"
          isOpen={modal}
          modalClassName="ltr-support"
          toggle={toggle}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              onClick={toggle}
            />
            <ModalHeader content={t('createCampaignPage.searchGenres')} />
          </div>

          <SimilarArtistContainer>
            <SimilarArtistSearchForm
              artists={artistsList}
              search={checkArtist || searchArtists}
              searchError={searchError}
              errorAnswerSpotify={errorAnswerSpotify}
              genresSelectedLength={selectedArtistGenresList.length}
              onChange={setSearchArtist}
            />
            {artistsList && (
              <WrapperRelativeArtists>
                {artistsList.length !== 0 && (
                  <CustomScrollDiv length={artistsList.length}>
                    <CheckArtistFromSearch
                      artists={artistsList}
                      onCheck={handleSetArtistGenresList}
                    />
                  </CustomScrollDiv>
                )}
              </WrapperRelativeArtists>
            )}
            {selectedArtistGenresList.length !== 0 && (
              <div className="form__form-group_artist">
                <div className="form__form-group">
                  <div className="form__form-group-field">
                    <StyledModalSubHeader>
                      <ModalSubHeaderContainer>
                        <ModalSubHeader
                          content={t('createCampaignPage.chooseGenresFromList')}
                        />
                      </ModalSubHeaderContainer>
                    </StyledModalSubHeader>

                    <div className="form-group-field-genres">
                      {selectedArtistGenresList.map(item => (
                        <div
                          key={item.genre_name}
                          className={
                            item.isCheked
                              ? 'checking form-group-field-genre-checked'
                              : 'checking form-group-field-genre'
                          }
                        >
                          <span
                            onClick={() =>
                              handleCheckArtistGenre(item.genre_name)
                            }
                          >
                            {item.genre_name}
                          </span>
                          {item.isCheked && (
                            <GenresUnchecked
                              onClick={() =>
                                handleUncheckArtistGenre(item.genre_name)
                              }
                            >
                              <IconClose />
                            </GenresUnchecked>
                          )}
                        </div>
                      ))}
                    </div>
                    {selectedArtistGenresList.length > 0 &&
                    selectedArtistGenresList.find(
                      item => item.isCheked !== false
                    ) ? (
                      <div className="checking form__form-group-field_button-block">
                        <StyledDiv>
                          <GreenBtn color="green" onClick={onSubmitDesktop}>
                            {t('createCampaignPage.addGenres')}
                          </GreenBtn>
                        </StyledDiv>
                      </div>
                    ) : (
                      <div className="form__form-group-field_button-block">
                        <StyledDiv>
                          <GreyBtnDisabled color="greyDisabled">
                            {t('createCampaignPage.addGenres')}
                          </GreyBtnDisabled>
                        </StyledDiv>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </SimilarArtistContainer>
        </Modal>
      </Desktop>
      <Mobile>
        <Modal
          fade={false}
          className="modal__mobile-dialog"
          isOpen={modal}
          modalClassName="modal__mobile"
          toggle={toggle}
        >
          <SimilarArtistContainer>
            <button
              className="modal__mobile--close lnr lnr-arrow-left"
              type="button"
              onClick={toggle}
            />

            <SimilarArtistSearchForm
              search={checkArtist || searchArtists}
              searchError={searchError}
              errorAnswerSpotify={errorAnswerSpotify}
              genresSelectedLength={selectedArtistGenresList.length}
              onChange={setSearchArtist}
            />

            {artistsList.length > 0 && (
              <WrapperForCloseBtn>
                <SmallButton onClick={handleSetSearchToInitial}>
                  <img src={closeCross} alt="clear-button" />
                </SmallButton>
              </WrapperForCloseBtn>
            )}
            {artistsList && (
              <CustomScrollDiv length={artistsList.length}>
                <CheckArtistFromSearch
                  artists={artistsList}
                  onCheck={handleSetArtistGenresList}
                />
              </CustomScrollDiv>
            )}
            {selectedArtistGenresList.length !== 0 && (
              <div className="form__form-group_artist">
                <div className="form__form-group">
                  <div className="form__form-group-field">
                    <ListWrapper>
                      <ListComponent
                        searchValue=""
                        chosenListIsOpen={chosenListIsOpen}
                        itemsType="similarArtist"
                        listedItems={selectedArtistGenresList}
                        setChosenListIsOpen={setChosenListIsOpen}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                        flow={flow}
                        campaignId={campaignId}
                      />
                    </ListWrapper>
                  </div>
                </div>
                {(selectedArtistGenresList.length > 0 &&
                  selectedArtistGenresList.find(
                    item => item.isCheked !== false
                  )) ||
                selectedItems.length > 0 ? (
                  <ButtonContainer>
                    <GreenBtn color="green" onClick={onSubmitMobile}>
                      {t('createCampaignPage.addGenres')}
                    </GreenBtn>
                  </ButtonContainer>
                ) : (
                  <ButtonContainer>
                    <GreyBtnDisabled color="greyDisabled">
                      {t('createCampaignPage.addGenres')}
                    </GreyBtnDisabled>
                  </ButtonContainer>
                )}
              </div>
            )}
          </SimilarArtistContainer>
        </Modal>
      </Mobile>
    </div>
  )
}

export default SimilarArtistPopup
